import { Box, Grid, Typography, useTheme } from '@mui/material';
import { FC, Fragment, JSX, useCallback, useEffect, useState } from 'react';
// components
import { DashboardStatsChartImg } from 'assets/svgs';
import DashboardStatsCard from '../DashboardStatsCard';
import UsersTableDashboard from './DashboardUsersTable';
// styles, interfaces
import {
  CURRENT_MONTH_USERS_TEXT,
  DASHBOARD_TEXT,
  HTTP_STATUS,
  superInitialValues,
  TOTAL_INGREDIENTS_TEXT,
  TOTAL_USERS_TEXT,
} from 'constants/index';
import { SuperDashboardPayload, useGetSuperDashboardLazyQuery } from 'generated/graphql';
import { flexCenterBetween } from 'styles/commonComponentStyle';

const SuperAdminDashboard: FC = (): JSX.Element => {
  const { palette } = useTheme();

  const [data, setData] = useState<SuperDashboardPayload>(superInitialValues);

  const [getSuperDashboard, { loading }] = useGetSuperDashboardLazyQuery({
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,

    onCompleted: (res) => {
      const { getSuperDashboard } = res || {};
      const { response } = getSuperDashboard || {};
      const { status } = response || {};

      if (status === HTTP_STATUS.SUCCESS) {
        setData(getSuperDashboard);
      } else {
        setData(superInitialValues);
      }
    },

    onError: () => {
      setData(superInitialValues);
    },
  });

  const fetchDashboard = useCallback(async () => {
    try {
      await getSuperDashboard();
    } catch (error) {
      console.log('error', error);
    }
  }, [getSuperDashboard]);

  useEffect(() => {
    fetchDashboard();
  }, [fetchDashboard]);

  const { ingredients, currentMonthUsers, users } = data || {};

  return (
    <Fragment>
      <Box sx={flexCenterBetween}>
        <Typography variant="h5" id={'dashboard-text'}>
          {DASHBOARD_TEXT}
        </Typography>
      </Box>
      <Grid container spacing={3} mt={1}>
        <Grid item xl={4} lg={6} md={6} sm={12} xs={12}>
          <DashboardStatsCard
            loading={loading}
            icon={<DashboardStatsChartImg color={palette.primary.main} />}
            stats={`${users ?? 0}`}
            title={TOTAL_USERS_TEXT}
          />
        </Grid>

        <Grid item xl={4} lg={6} md={6} sm={12} xs={12}>
          <DashboardStatsCard
            loading={loading}
            icon={<DashboardStatsChartImg color={palette.bluePaletteColor.main} />}
            stats={`${ingredients ?? 0}`}
            title={TOTAL_INGREDIENTS_TEXT}
          />
        </Grid>

        <Grid item xl={4} lg={6} md={6} sm={12} xs={12}>
          <DashboardStatsCard
            loading={loading}
            icon={<DashboardStatsChartImg color={palette.customRedColor.main} />}
            stats={`${currentMonthUsers ?? 0}`}
            title={CURRENT_MONTH_USERS_TEXT}
          />
        </Grid>
      </Grid>

      <Grid container spacing={3} mt={1}>
        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
          <UsersTableDashboard />
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default SuperAdminDashboard;
